<template>
  <div>
    <div
      v-if="section"
      class="font-weight-bold text-center mb-1"
    >
      {{ getTranslatedField(section, 'name') }}
    </div>

    <div
      v-if="search"
      class="font-weight-bold text-center mb-1"
    >
      {{ $t('help.search-result-for', [search]) }}
    </div>

    <vue-perfect-scrollbar
      class="scrollable-container questions scroll-area list-group border"
      tagname="div"
    >
      <template v-for="(question, questionIdx) in questions">
        <b-list-group-item :key="questionIdx">
          <div
            class="font-weight-bold d-flex justify-content-between align-items-center cursor-pointer"
            @click="openedQuestionId = openedQuestionId === question.id ? null : question.id"
          >
            <div v-html="question.question" />

            <feather-icon
              v-if="questions.length > 1"
              :icon="openedQuestionId === question.id ? 'ChevronUpIcon' : 'ChevronDownIcon'"
              class="text-secondary"
            />
          </div>
          <slide-y-up-transition>
            <div
              v-show="openedQuestionId === question.id || questions.length === 1"
              class="font-weight-normal text-normal answer"
              v-html="question.answer"
            />
          </slide-y-up-transition>
        </b-list-group-item>
      </template>
      <b-list-group-item v-if="!questions.length && section">
        <div class="font-weight-semi-bold text-secondary py-2 text-center">
          {{ $t('help.no-search-result') }} <br>
          <span
            class="text-underline font-weight-bold cursor-pointer"
            @click="$emit('update:section', null); $emit('update:search', '')"
          >
            {{ $t('help.try-search-in-all-sections') }}
          </span>
        </div>
      </b-list-group-item>
    </vue-perfect-scrollbar>

    <div class="text-center py-1">
      <span
        class="font-weight-semi-bold text-underline text-secondary cursor-pointer"
        @click="$emit('update:section', null); $emit('update:search', '')"
      >
        {{ $t('help.view-help-sections') }}
      </span>
    </div>
  </div>
</template>

<script>
import { BListGroupItem } from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import LocalizationMixin from '@/mixins/localization-mixin'

export default {
  name: 'HelpQuestionsList',
  components: {
    BListGroupItem,
    VuePerfectScrollbar,
  },
  mixins: [LocalizationMixin],
  props: {
    search: {
      type: String,
      default: '',
    },
    section: {
      type: Object,
      default: null,
    },
    questions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      openedQuestionId: null,
    }
  },
}
</script>
